import React from 'react'

type DurationState = 'start' | 'running' | 'complete'

export function useOneshotDuration(duration: number, preDelay: number): DurationState {
  const isInstant = duration + preDelay === 0
  const [state, setState] = React.useState<DurationState>( isInstant? 'complete' : 'start')

  React.useEffect(() => {
    if (!isInstant) {
      const timer = setTimeout(() => {
        setState('running')
      }, preDelay)

      return () => {
        clearTimeout(timer)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useLayoutEffect(() => {
    if (!isInstant) {
      const timer = window.setTimeout(() => {
        setState('complete')
      }, duration + preDelay)

      return () => {
        clearTimeout(timer)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return state
}
